import ApiService from '../index'

export const profiles = async (query) => {
  const URI = `/api/profile?${new URLSearchParams(query)}`

  const response = await ApiService.get(URI)

  return response.data
}

// ===== NOT IMPLEMENTED YET ======
// => begin

export const deleteProfile = async (id) => {
  const URI = `/api/profile/${id}`

  const response = await ApiService.delete(URI)

  return response
}

// => end

export const addProfile = async (profile) => {
  const URI = `/api/profile`

  const response = await ApiService.post(URI, profile)

  return response.data
}

export const updateProfile = async (profile) => {
  const URI = `/api/profile/${profile.id}`

  const response = await ApiService.patch(URI, profile)

  return response.data
}
